import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {Localization} from '../../../../projects/common/src/lib/interface/localization.extension';
import {CookieConsentService} from './cookie-consent.service';

/**
 * The first layer of cookie consent.
 *
 * What the AEPD's cookie guide asks of it: say who is asking and for what,
 * offer accepting and rejecting with the same weight -- same size, same style,
 * side by side -- plus a way into the details, and link the full policy. It
 * does not block the app: nothing optional runs while it waits, so there is
 * no reason to hold anyone up, and a wall would not make the consent valid.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: 'cookie-banner.component.html',
  styleUrls: ['cookie-banner.component.scss'],
})
export class CookieBannerComponent extends Localization {
  readonly consent = inject(CookieConsentService);
}
